// Name fallback for Home's "Profile visitors" tile (recentProfileVisitors).
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function visitorName(v: any): string {
  if (v?.person?.formattedName) return v.person.formattedName;
  const given = (v?.person?.name?.given ?? []).filter(Boolean).join(" ");
  return [given, v?.person?.name?.family].filter(Boolean).join(" ") || "–";
}
